export default __webpack_public_path__ + "static/media/lulu_masunga.9ef71330.mp3";